module.exports = __webpack_public_path__ + "img/D201510_5.e303bc78.jpg";